import NoToken from "./NoToken.vue";

export default [
  {
    path: '/no-token',
    name: 'no-token',
    component: NoToken
  }
]